import { createPortal } from 'react-dom';
import { LogOut, Save, X, AlertTriangle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const LogoutConfirmModal = ({ isOpen, onClose, onSaveAndLogout, onLogoutWithoutSave }) => {
  const { t } = useLanguage();
  
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative w-full max-w-md bg-zinc-900 border border-zinc-700 rounded-xl shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="flex items-center gap-3 px-5 py-4 border-b border-zinc-700 bg-gradient-to-r from-amber-900/30 to-orange-900/30">
          <div className="p-2 bg-amber-600/20 rounded-lg">
            <AlertTriangle className="w-5 h-5 text-amber-400" />
          </div>
          <div>
            <h3 className="font-semibold text-white">{t('logout.title')}</h3>
            <p className="text-xs text-zinc-400">{t('logout.saveReminder')}</p>
          </div>
        </div>

        {/* Body */}
        <div className="p-5">
          <p className="text-sm text-zinc-300 mb-6">
            {t('logout.message')}
          </p>

          <div className="space-y-3">
            {/* Save and Logout */}
            <button
              onClick={onSaveAndLogout}
              className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-green-600 hover:bg-green-500 text-white font-medium rounded-lg transition-colors"
              data-testid="save-and-logout-btn"
            >
              <Save className="w-5 h-5" />
              {t('common.save')} & {t('logout.title')}
            </button>

            {/* Logout without save */}
            <button
              onClick={onLogoutWithoutSave}
              className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-red-600/20 hover:bg-red-600/30 text-red-400 font-medium rounded-lg transition-colors border border-red-600/30"
              data-testid="logout-without-save-btn"
            >
              <LogOut className="w-5 h-5" />
              {t('logout.confirm')}
            </button>

            {/* Cancel */}
            <button
              onClick={onClose}
              className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-zinc-800 hover:bg-zinc-700 text-zinc-300 font-medium rounded-lg transition-colors"
              data-testid="cancel-logout-btn"
            >
              <X className="w-5 h-5" />
              {t('logout.cancel')}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LogoutConfirmModal;
